import { ChartStyleColorModel } from "../chart-style/chart-style-color.model";

export class CompanyLogoDataModel {
    public companyLogoUrl = ''; 
    public fallbackColor = new ChartStyleColorModel();
   
    constructor(companyLogoData?: any) {
        if (companyLogoData) {
            this.companyLogoUrl = companyLogoData.companyLogoUrl;
            this.fallbackColor = new ChartStyleColorModel(companyLogoData.fallbackColor);
        }
    }

    public hasValue() : boolean{
        return !!this.companyLogoUrl;
    }

    public doesNotHaveValue() : boolean{
        return !this.hasValue();
    }
}
